/* eslint-disable react/prop-types */
import {
  Drawer,
  Paragraph,
  Typography as HeaderTitle,
} from '@tmov/design-system';
import { format } from 'date-fns';
import React from 'react';

import {
  formatarMoeda,
  formatarTonelada,
} from '../../../../helpers/formatador';
import {
  ContainerLance,
  DescricaoContainer,
  DollarContainer,
  DollarIcon,
} from './styles';

function DrawerHistorico({ propostas, visible, handleClose }) {
  return (
    <Drawer
      style={{
        width: '460px',
      }}
      header={<HeaderTitle variant="h4">Historico de lances</HeaderTitle>}
      active={visible}
      updateActive={handleClose}
    >
      {propostas.length &&
        propostas.map(proposta => (
          <ContainerLance>
            <DollarContainer>
              <DollarIcon />
            </DollarContainer>
            <DescricaoContainer>
              <Paragraph>{proposta.razao_social}</Paragraph>
              <Paragraph fontWeight="semibold">
                {formatarMoeda(proposta.valor_lance)}
                {' • '}
                {formatarTonelada(proposta.volume, 0, 'ton')}
              </Paragraph>
              <Paragraph variant="p2">
                {format(new Date(proposta.created_at), "dd/MM/yyyy 'às' HH:mm")}
              </Paragraph>
            </DescricaoContainer>
          </ContainerLance>
        ))}
    </Drawer>
  );
}

export default DrawerHistorico;
